import { Box, Checkbox, FormControlLabel, Grid, Radio, Typography } from "@mui/material"
import { useDetailTypeOfResponse } from "./detailTypeOfResponse"
import { DetailTypeOfResponseProps } from "./type"
import { Images } from "../image"
import { CatalogQuestionDetail } from "../../pages/questionnaire/components/catalogQuestionDetail"

const DetailTypeOfResponse = (props: DetailTypeOfResponseProps) => {
    const size = props?.answersList?.length > 1 ? 6 : 12
    const styles = useDetailTypeOfResponse()
    switch (props?.type) {
        case 2:
            return (
                <Grid container sx={styles.optionsContainer} spacing={1}>
                    {props?.answersList?.map((item) => (
                        <Grid key={item.id} item xs={size}>
                            <FormControlLabel key={item.id} control={<Checkbox disableFocusRipple disableTouchRipple disableRipple checked={!!item.value} />} label={item.label} />
                        </Grid>
                    ))}
                </Grid>
            )
        case 3: return <>{props?.answersList?.map((item) => (<Typography sx={styles.free} key={item.id}>{item.label}</Typography>))}</>
        case 1:
        case 4:
            return (
                <Grid container sx={styles.optionsContainer} spacing={1}>
                    {props?.answersList?.map((item) => (
                        <Grid key={item.id} item xs={size}>
                            <FormControlLabel
                                sx={{ alignItems: (!!item.iconUrl && props?.type == 4) ? 'start' : 'center !important' }}
                                key={item.id}
                                control={<Radio disableFocusRipple disableTouchRipple disableRipple checked={!!item.value} />}
                                label={
                                    <Box sx={styles.iconContainer}>
                                        {
                                            (!!item.iconUrl && props?.type == 4) && (
                                                <Images src={item.iconUrl} sx={styles.icon} />
                                            )
                                        }

                                        <Typography sx={{ width: (!!item.iconUrl && props?.type == 4) ? 'calc(100% - 30px)' : '100%' }}>{item.label}</Typography>
                                    </Box>
                                }
                            />
                        </Grid>
                    ))}
                </Grid>
            )
        case 5:
            return (
                <>
                {props.fullAnswer && <CatalogQuestionDetail list={props.fullAnswer}/>}
                </>
            )
        default:
            return <></>
    }
}

export { DetailTypeOfResponse }